import React from "react";

import { Form } from "affinityForm";
import { ExecuteButton } from "affinityForm/components/executeButton";
import { DateField, InputField } from "affinityForm/fields";
import { TimeField } from "affinityForm/fields/time";
import { DataElement } from "affinityUI/data/dataElement";
import { DateTime } from "affinityUI/data/valueDisplay";
import { ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { Grid } from "affinityUI/elements/grid";
import { ButtonGroup, DataEntryGroup } from "affinityUI/form/components";
import type { PatientData } from "types/patient";

const checkManualInput = (nextValue: string, prevValue: string) => {
  return /^[<>]?\d*\.?\d*$/gm.test(nextValue) ? nextValue : prevValue;
};

export const ResultsEditForm: React.FC<{ patient: Omit<PatientData, "consent"> }> = ({ patient }) => {
  return (
    <Grid>
      <Card>
        <DataEntryGroup id="patient-details" title="Patient details">
          <Grid $cols={Grid.cols.EQUAL}>
            <DataElement label="DOB">
              <DateTime value={patient?.dateOfBirth} format={DateTime.FORMAT.DATE} />
            </DataElement>
            <DataElement label="Hospital number">{patient.hospitalNumber}</DataElement>
          </Grid>
        </DataEntryGroup>
      </Card>
      <Card data-testid="add-result-form">
        <Form>
          <DataEntryGroup title="Test details" id="test-details">
            <Grid $cols={[1, 1]}>
              <DateField name="dateRecorded">Date of test</DateField>
            </Grid>
            <TimeField name="timeRecorded">Time of test (24 hr format)</TimeField>
          </DataEntryGroup>
          <DataEntryGroup title="Results" id="results">
            <Grid $cols={[1, 1]}>
              <div>
                <InputField updateValue={checkManualInput} name="whiteBloodCells.value">
                  WBC (10⁹/L)
                </InputField>
                <InputField updateValue={checkManualInput} name="neutrophils.value">
                  Neutrophils (10⁹/L)
                </InputField>
                <InputField updateValue={checkManualInput} name="haemoglobin.value">
                  Haemoglobin (g/L)
                </InputField>
                <InputField updateValue={checkManualInput} name="platelets.value">
                  Platelets (10⁹/L)
                </InputField>
              </div>
            </Grid>
          </DataEntryGroup>
          <ButtonGroup>
            <NavigateButton to="../.." variant={ButtonVariants.SECONDARY}>
              Cancel
            </NavigateButton>
            <ExecuteButton>Next</ExecuteButton>
          </ButtonGroup>
        </Form>
      </Card>
    </Grid>
  );
};

export * from "./validationSchema";
